"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXPANDABLE_PADDING_X = exports.EXPANDABLE_PADDING_TOP = exports.EXPANDABLE_PADDING_LEFT = exports.EXPANDABLE_PADDING_BOTTOM = exports.EXPANDABLE_OPENER_HOVER_COLOR = exports.EXPANDABLE_OPENER_DISABLED_COLOR = exports.EXPANDABLE_OPENER_COLOR = exports.EXPANDABLE_DARK_PADDING_TOP = exports.EXPANDABLE_DARK_BACKGROUND = exports.EXPANDABLE_DARK_BORDER_COLOR = exports.EXPANDABLE_ACTIONS_SPACING_X = void 0;

var _colors = require("HubStyleTokens/colors");

var EXPANDABLE_ACTIONS_SPACING_X = '8px';
exports.EXPANDABLE_ACTIONS_SPACING_X = EXPANDABLE_ACTIONS_SPACING_X;
var EXPANDABLE_DARK_BORDER_COLOR = _colors.BATTLESHIP;
exports.EXPANDABLE_DARK_BORDER_COLOR = EXPANDABLE_DARK_BORDER_COLOR;
var EXPANDABLE_DARK_BACKGROUND = _colors.GYPSUM;
exports.EXPANDABLE_DARK_BACKGROUND = EXPANDABLE_DARK_BACKGROUND;
var EXPANDABLE_DARK_PADDING_TOP = '20px';
exports.EXPANDABLE_DARK_PADDING_TOP = EXPANDABLE_DARK_PADDING_TOP;
var EXPANDABLE_OPENER_COLOR = _colors.CALYPSO;
exports.EXPANDABLE_OPENER_COLOR = EXPANDABLE_OPENER_COLOR;
var EXPANDABLE_OPENER_DISABLED_COLOR = _colors.BUTTON_DISABLED_TEXT;
exports.EXPANDABLE_OPENER_DISABLED_COLOR = EXPANDABLE_OPENER_DISABLED_COLOR;
var EXPANDABLE_OPENER_HOVER_COLOR = _colors.LINK_HOVER;
exports.EXPANDABLE_OPENER_HOVER_COLOR = EXPANDABLE_OPENER_HOVER_COLOR;
var EXPANDABLE_PADDING_BOTTOM = '24px';
exports.EXPANDABLE_PADDING_BOTTOM = EXPANDABLE_PADDING_BOTTOM;
var EXPANDABLE_PADDING_LEFT = '44px';
exports.EXPANDABLE_PADDING_LEFT = EXPANDABLE_PADDING_LEFT;
var EXPANDABLE_PADDING_TOP = '4px';
exports.EXPANDABLE_PADDING_TOP = EXPANDABLE_PADDING_TOP;
var EXPANDABLE_PADDING_X = '20px';
exports.EXPANDABLE_PADDING_X = EXPANDABLE_PADDING_X;